import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

//styles
import '../styles/introStyle.scss';
import '../styles/transition-group.scss';
import '../styles/transition-fadeUp.scss';


import Shareelement from './shareelement';
import Warenkorb from './warenkorb_menu';

import WifiView from './wifi';
import TwitterFallback from './twitter_fallback';


import Iconset from './icons';
import Loaderelement from './loaderelement';

import ChapterInlineNavi from './chapter_inline_navi';


class Intro extends React.Component{
	constructor(props){
		super(props);
		this.state = {
	    loadStatus : 0,
	    introScreen:true,
	    isLoading : false,
	    isMobile : _assets.isMobile,
	    orientation : 0, // portrait
	  	orientationCount : 0,
	  }
	}

	componentDidMount(){
	  this.addHandler();

	  setTimeout(function(){
	  	if(this.state.orientation == 1){
		  	this.setState({
		  		orientationCount : 1
		  	});
	  	}else{
	  		this.setState({
		  		orientationCount : 2
		  	});
	  	}

	  	localStorage.setItem('coming-from-intro', true);
	  	localStorage.setItem('wifi-was-visible', true);
	  }.bind(this),4000);
	}

	getOrientation(){

		if(window.innerWidth > window.innerHeight){
			this.setState({
				orientation : 1
			});

			if(this.state.orientationCount == 2){
				this.setState({
					orientationCount : 1
				});
			}
		}else{
			this.setState({
				orientation : 0
			});
		}
	}

	addHandler(){
		this.getOrientation();
		window.addEventListener('resize',()=>this.getOrientation());
	}

  startIntro(){
  	this.props.changeinnerChapter();
  }

  render(){
		return (
			<div className="intro-chapter">

			{/*Twitter*/}
			{_assets.isTwitter &&
			 	<TwitterFallback />
			}
			{/*Wifi*/}
				<ReactCSSTransitionGroup
					component= "div"
					className="inner-wifi-holder"
				  transitionName="fade"
				  transitionAppear={true}
	     		transitionAppearTimeout={500}
				  transitionEnterTimeout={500}
				  transitionLeaveTimeout={300}>
						{this.state.isMobile && this.state.orientationCount != 1 &&
				    	<WifiView orientation={this.state.orientation} />
				    }

	      </ReactCSSTransitionGroup>

			{/*Menu*/}
				<ReactCSSTransitionGroup
					component= "div"
					className="inner-menu-holder"
				  transitionName="fade"
				  transitionAppear={true}
	     		transitionAppearTimeout={500}
				  transitionEnterTimeout={500}
				  transitionLeaveTimeout={300}>
						{this.state.introScreen &&
							<main className={"main-intro-screen loading-" + !this.props.firstSession}>
								<div className="logo-icon">
									<Iconset.logo />
								</div>
								<div className="main-center-screen">
									<header>
										<div className="load-status">
											<Loaderelement
											isLoading={!this.props.firstSession}/>
											<h1>A Blossomentary</h1>
											<p>Get more inside information on Milky Chance here! Find out what brought Clemens and Philipp together, how they create music and what’s behind their new album.</p>
										</div>
									</header>
										<ReactCSSTransitionGroup
											component= "div"
											className="main-intro-screen-inner"
										  transitionName="fade"
										  transitionAppear={true}
								   		transitionAppearTimeout={500}
										  transitionEnterTimeout={500}
										  transitionLeaveTimeout={300}>
													<ChapterInlineNavi inline={false} list={true}/>
										</ReactCSSTransitionGroup>
									</div>
								<ReactCSSTransitionGroup
											component= "div"
											className="footer-holder"
										  transitionName="fadeUp"
										  transitionAppear={true}
								   		transitionAppearTimeout={500}
										  transitionEnterTimeout={500}
										  transitionLeaveTimeout={300}>
													<footer>
													<Warenkorb />
													{ !_assets.isMobile && 
														<div className="audio-message">
															<div className="headPhones-icon">
																<Iconset.headPhones />
															</div>
															<p>Use your headphones for best experience</p>
														</div>
													}
													<Shareelement chapter="home"/>
													</footer>
												
										</ReactCSSTransitionGroup>
								</main>
						}
					</ReactCSSTransitionGroup>
		</div>);
	}
}


export default Intro;


// WEBPACK FOOTER //
// ./src/scripts/intro.js